module.exports = __webpack_public_path__ + "static/media/CheckatradeLogo.f6883031.png";